<div
    class="richtext-content"
    [innerHTML]="ritchtextBlock().translations_refs | getTranslation: 'content' | trustedHtml"
></div>
